<template>
  <p><strong>Создание (регистрация) новых обращений по инцидентам</strong></p>
  <p>Для того, чтобы зарегистрировать новое обращение необходимо перейти на страницу подачи обращений: </p>
  <img src="@/assets/instruction/4.png">
  <p>Перед пользователем откроется <strong>ПОШАГОВАЯ</strong> форма создания обращений:</p>
  <img src="@/assets/instruction/5.png">
  <p>Далее необходимо пошагово заполнить все поля в соответствии с подсказками в выпадающих списках:</p>
  <img src="@/assets/instruction/6.png">
  <p>После успешного заполнения поля – автоматически появится новое поле, и так шаг за шагом.</p>
  <img src="@/assets/instruction/7.png">
  <p><i>В поле <strong>местоположение</strong> необходимо указать Титул здания или название КПП.</i></p>
  <img src="@/assets/instruction/8.png">
  <img src="@/assets/instruction/9.png">
  <img src="@/assets/instruction/10.png">
  <p>После заполнения поля «Неисправность» появится широкое поле ввода «Описание» - в данное поле необходимо указать описание неисправности в свободной форме, после чего форма будет готова к отправке:</p>
  <p>Примечание: проверьте указанный «Приоритет» и «Вид сервиса».</p>
  <p>Для обычного обращения по неисправности, должно быть выбрано: «Инцидент (Аварийное обращение)»</p>
  <img src="@/assets/instruction/11.png">
  <img src="@/assets/instruction/12.png">
  <img src="@/assets/instruction/13.png">
  <p>После полной проверки заполненной формы можно создать обращение, нажав кнопку <span class="button tag is-light">ПОДАТЬ ОБРАЩЕНИЕ</span></p>
  <p>После успешной регистрации обращения на экране появится следующее окно:</p>
  <img src="@/assets/instruction/14.png">
  <p>Теперь можно перейти к списку обращений, воспользовавшись кнопкой: <span class="button tag is-dark">К ОБРАЩЕНИЯМ</span></p>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Create"
}
</script>

<style scoped>

</style>